"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { useDeepEffect } from '../../../../helpers/hooks/useDeepEffect.mjs';
import { createContext, useId, useContext, useEffect } from 'react';

const NavigationContext = createContext({
  currentItem: null,
  moveToNextItem: () => null,
  moveToPreviousItem: () => null,
  onOptionsListChange: () => null
});
function useNavigationContext(options = [], fallbackOptions = []) {
  const sourceId = useId();
  const { currentItem, moveToNextItem, moveToPreviousItem, onOptionsListChange } = useContext(NavigationContext);
  useDeepEffect(() => {
    onOptionsListChange({
      sourceId,
      options,
      fallbackOptions
    });
  }, [options, fallbackOptions]);
  useEffect(() => {
    return () => {
      onOptionsListChange({
        sourceId,
        options: [],
        fallbackOptions: []
      });
    };
  }, []);
  return {
    currentItem,
    moveToNextItem,
    moveToPreviousItem
  };
}

export { NavigationContext, useNavigationContext };
